import { createRequestTypes } from '../utils';

export const INCI_LIST_FOR_PRODUCT = createRequestTypes('inciList/INCI_LIST_FOR_PRODUCT');
